import React from 'react'

export default function SourceChip({ source, index }) {
  const label = [ source.person_name, source.company_name ].filter(Boolean).join(' · ')
  // Phase 1 collapsed InterviewResponse into Response, so the polymorphic
  // type string the backend now sends is 'Response'.
  const sourceLabel = source.artifact_name || (source.source_type === 'Response' ? 'Interview' : source.source_type)

  return (
    <div
      title={source.chunk_text}
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs text-slate-700 hover:border-accent-300 hover:text-slate-900 transition"
    >
      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-50 text-[10px] font-semibold text-accent-700">
        {index + 1}
      </span>
      <span className="font-medium">{label || 'Source'}</span>
      {sourceLabel && (
        <span className="text-slate-400 truncate max-w-[180px]">— {sourceLabel}</span>
      )}
    </div>
  )
}
